export default "__VITE_ASSET__fd919ff5__"